import React, { useState, useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import api from '../../../services/api';

const Step3PWD = () => {
    const { mockUser, refreshUser } = useOutletContext();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        pwbdCandidate: '2', // 1=Yes, 2=No (Default No)
        disabilityType: '',
        disabilityPercentage: '',
        scribeNeeded: '2', // 1=Yes, 2=No
        captcha: ''
    });

    // Load Data
    useEffect(() => {
        const init = async () => {
            try {
                const res = await api.get(`/mock-cuet/application-data?mockAppId=${mockUser.id}`);
                if (res.data.success) {
                    const dbData = res.data.data;
                    
                    setFormData(prev => ({
                        ...prev,
                        pwbdCandidate: dbData.pwbd_candidate === 1 ? '1' : '2',
                        disabilityType: dbData.disability_type || '',
                        disabilityPercentage: dbData.disability_percentage || '',
                        scribeNeeded: dbData.scribe_needed === 1 ? '1' : '2',
                    }));
                }
            } catch (err) { console.error(err); }
        };
        init();
    }, [mockUser]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Simulation Confirmation
        if(!window.confirm('Are you sure you want to submit this section?')) {
            return;
        }

        setLoading(true);

        try {
            const res = await api.post('/mock-cuet/save-step', {
                mockAppId: mockUser.id,
                stepNumber: 3,
                stepData: formData,
                nextStepNumber: 4
            });

            if (res.data.success) {
                refreshUser(4);
                navigate('/services/counselling/dashboard/identity-details');
            }
        } catch (err) {
            alert("Error saving data");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="ctl00_ContentPlaceHolder1_pnlApplicationForm">
            <div className="appstatus" style={{ paddingTop: '0px', marginTop: '0px' }}>
                <div className="container-fluid contentmid" style={{padding:0}}>
                    
                    <h4>विकलांगता विवरण (Disability Details)</h4>
                    
                    <div className="form-horizontal formLabel">
                        
                        {/* Main Dropdown */}
                        <div className="form-group">
                            <label className="control-label col-sm-4">
                                <span>क्या आप PwD/PwBD उम्मीदवार हैं? (Are you PwD/PwBD Candidate)?</span>
                            </label>
                            <div className="col-sm-4">
                                <select 
                                    name="pwbdCandidate" 
                                    className="form-control" 
                                    value={formData.pwbdCandidate} 
                                    onChange={handleChange}
                                >
                                    <option value="0">--Select--</option>
                                    <option value="1">Yes</option>
                                    <option value="2">No</option>
                                </select>
                            </div>
                        </div>

                        {/* Conditional Fields (Only if Yes) */}
                        {formData.pwbdCandidate === '1' && (
                            <>
                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        <span>विकलांगता का प्रकार (Type of Disability)</span>
                                    </label>
                                    <div className="col-sm-4">
                                        <select name="disabilityType" className="form-control" value={formData.disabilityType} onChange={handleChange}>
                                            <option value="">--Select--</option>
                                            <option value="Locomotor">Locomotor Disability</option>
                                            <option value="Visual">Visual Impairment</option>
                                            <option value="Hearing">Hearing Impairment</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        <span>विकलांगता का प्रतिशत (Percentage of Disability)</span>
                                    </label>
                                    <div className="col-sm-4">
                                        <input 
                                            name="disabilityPercentage" 
                                            type="text" 
                                            className="form-control" 
                                            placeholder="%"
                                            value={formData.disabilityPercentage} 
                                            onChange={handleChange} 
                                        />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="control-label col-sm-4">
                                        <span>क्या आपको स्क्राइब की आवश्यकता है? (Do you need a Scribe?)</span>
                                    </label>
                                    <div className="col-sm-4">
                                        <select name="scribeNeeded" className="form-control" value={formData.scribeNeeded} onChange={handleChange}>
                                            <option value="0">--Select--</option>
                                            <option value="1">Yes</option>
                                            <option value="2">No</option>
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}

                        <br />

                        {/* CAPTCHA */}
                        <div id="ctl00_ContentPlaceHolder1_pnlFinalSubmit">
                            <h4>CAPTCHA</h4>
                            <div className="form-group">
                                <label className="control-label col-sm-4">
                                    Enter CAPTCHA as shown below <span className="text-primary">(case sensitive)</span>
                                </label>
                                <div className="col-sm-4">
                                    <input name="captcha" type="text" className="form-control" value={formData.captcha} onChange={handleChange} required />
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="control-label col-sm-4">CAPTCHA</label>
                                <div className="col-sm-4">
                                     <div style={{display:'inline-block', verticalAlign:'middle'}}>
                                        <img src="/assets/cuet-mock/images/DisplayCaptchaImg.jpg" alt="Captcha" style={{height:'34px', borderWidth:'0px'}} />
                                     </div>
                                     <div style={{display:'inline-block', verticalAlign:'middle', marginLeft:'10px'}}>
                                        <img src="/assets/cuet-mock/images/Refresh.png" alt="Refresh" style={{height:'30px', width:'30px', cursor:'pointer'}} />
                                     </div>
                                </div>
                            </div>
                            
                            <div className="form-group">
                                <div className="col-sm-12 text-center" style={{marginTop:'20px'}}>
                                    <button 
                                        type="button" 
                                        className="btn btn-warning" 
                                        onClick={() => navigate('/services/counselling/dashboard/personal-details')} 
                                        style={{marginRight:'10px'}}
                                    >
                                        Back
                                    </button>
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary" 
                                        onClick={handleSubmit} 
                                        disabled={loading}
                                    >
                                        {loading ? 'Saving...' : 'Submit & Next'}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step3PWD;